module.exports = __webpack_public_path__ + "static/media/sphere.ffabf11a.m4a";